export default __webpack_public_path__ + "static/media/3138.182bd310.jpg";